(function () {
  'use strict';

  var ROOT_CLASS = 'custom-cursor-enabled';

  if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

  var fineQuery = window.matchMedia('(any-pointer: fine)');
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!fineQuery.matches || motionQuery.matches) return;

  var HOVER_SELECTOR = 'a, button, input, textarea, select, label,[role="button"], [role="link"],' +
    '.accordion__summary, .image-magnify-hover, .pvr-slide__media, .image-with-hotspots__dot,' +
    '.price-range__thumbs, .stories__products-title, .button--modal-opener,' +
    '.button, .btn, .tab-js, .slider-scrollbar__track, .slider-scrollbar__thumb, [data-cursor-hover]';

  // Interactive elements that should NOT trigger the ring scale.
  // Mark any element (or its ancestor) with data-cursor-no-hover / .no-cursor-hover.
  var HOVER_EXCLUDE = '.disabled, [disabled], .pickup-availability--unavailable,' +
  '[data-cursor-no-hover], .no-cursor-hover';

  // Zones where the custom cursor is fully suppressed and the native pointer
  // returns (embeds, video, maps, 3D viewers). Extend via data-cursor-ignore

  var IGNORE_SELECTOR = '.ignore-custom-cursor';

  var DOT_EASE = 0.35;
  var RING_EASE = 0.18;
  var SCALE_EASE = 0.2;
  var RING_HOVER_SCALE = 1.6;
  var EPSILON = 0.1;

  var dotEl = null;
  var ringEl = null;

  var pointer = { x: 0, y: 0 };
  var dot = { x: 0, y: 0, halfW: 6, halfH: 6 };
  var ring = { x: 0, y: 0, halfW: 36, halfH: 36, scale: 1, targetScale: 1 };

  var rafId = null;
  var running = false;
  var visible = false;
  var seenPointer = false;
  var ignored = false;

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function measure() {
    dot.halfW = dotEl.offsetWidth / 2 || 6;
    dot.halfH = dotEl.offsetHeight / 2 || 6;
    ring.halfW = ringEl.offsetWidth / 2 || 36;
    ring.halfH = ringEl.offsetHeight / 2 || 36;
  }

  function onPointerMove(event) {
    pointer.x = event.clientX;
    pointer.y = event.clientY;

    if (!seenPointer) {
      seenPointer = true;
      dot.x = pointer.x;
      dot.y = pointer.y;
      ring.x = pointer.x;
      ring.y = pointer.y;
    }

    if (ignored) return;
    if (!visible) show();
    start();
  }

  function onPointerLeave() {
    hide();
  }

  function onPointerEnter() {
    if (seenPointer) show();
  }

  function setHover(state) {
    var target = state ? RING_HOVER_SCALE : 1;
    if (ring.targetScale === target) return;
    ring.targetScale = target;
    dotEl.classList.toggle('is-hover', state);
    ringEl.classList.toggle('is-hover', state);
    start();
  }

  function setIgnored(state) {
    if (ignored === state) return;
    ignored = state;

    if (state) {
      setHover(false);
      hide();
      stop();
      return;
    }

    // Leaving an ignored zone: snap to the current pointer to avoid a fly-in.
    dot.x = pointer.x;
    dot.y = pointer.y;
    ring.x = pointer.x;
    ring.y = pointer.y;
    if (seenPointer) {
      show();
      start();
    }
  }

  function onOver(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest(IGNORE_SELECTOR)) {
      setIgnored(true);
      return;
    }

    if (ignored) setIgnored(false);

    if (target.closest(HOVER_SELECTOR) && !target.closest(HOVER_EXCLUDE)) {
      setHover(true);
    }
  }

  function onOut(event) {
    var to = event.relatedTarget;
    if (to && to.closest && to.closest(HOVER_SELECTOR)) return;
    setHover(false);
  }

  function show() {
    visible = true;
    dotEl.classList.remove('is-hidden');
    ringEl.classList.remove('is-hidden');
  }

  function hide() {
    visible = false;
    dotEl.classList.add('is-hidden');
    ringEl.classList.add('is-hidden');
  }

  function render() {
    dot.x = lerp(dot.x, pointer.x, DOT_EASE);
    dot.y = lerp(dot.y, pointer.y, DOT_EASE);
    ring.x = lerp(ring.x, pointer.x, RING_EASE);
    ring.y = lerp(ring.y, pointer.y, RING_EASE);
    ring.scale = lerp(ring.scale, ring.targetScale, SCALE_EASE);

    dotEl.style.transform =
      'translate3d(' + (dot.x - dot.halfW) + 'px,' + (dot.y - dot.halfH) + 'px,0)';
    ringEl.style.transform =
      'translate3d(' + (ring.x - ring.halfW) + 'px,' + (ring.y - ring.halfH) + 'px,0) scale(' + ring.scale + ')';

    var settled =
      Math.abs(dot.x - pointer.x) < EPSILON &&
      Math.abs(dot.y - pointer.y) < EPSILON &&
      Math.abs(ring.x - pointer.x) < EPSILON &&
      Math.abs(ring.y - pointer.y) < EPSILON &&
      Math.abs(ring.scale - ring.targetScale) < EPSILON;

    if (settled) {
      dot.x = pointer.x; dot.y = pointer.y;
      ring.x = pointer.x; ring.y = pointer.y;
      ring.scale = ring.targetScale;
      dotEl.style.transform =
        'translate3d(' + (dot.x - dot.halfW) + 'px,' + (dot.y - dot.halfH) + 'px,0)';
      ringEl.style.transform =
        'translate3d(' + (ring.x - ring.halfW) + 'px,' + (ring.y - ring.halfH) + 'px,0) scale(' + ring.scale + ')';
      stop();
      return;
    }

    rafId = window.requestAnimationFrame(render);
  }

  function start() {
    if (running) return;
    running = true;
    rafId = window.requestAnimationFrame(render);
  }

  function stop() {
    running = false;
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function bind() {
    document.addEventListener('pointermove', onPointerMove, { passive: true });
    document.addEventListener('pointerdown', onPointerMove, { passive: true });
    document.addEventListener('mouseleave', onPointerLeave);
    document.addEventListener('mouseenter', onPointerEnter);
    document.addEventListener('mouseover', onOver, { passive: true });
    document.addEventListener('mouseout', onOut, { passive: true });
    window.addEventListener('resize', measure, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (visible) start();
    });

    var onMotionChange = function () {
      if (motionQuery.matches) destroy();
    };
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
    else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
  }

  function destroy() {
    stop();
    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerdown', onPointerMove);
    document.removeEventListener('mouseleave', onPointerLeave);
    document.removeEventListener('mouseenter', onPointerEnter);
    document.removeEventListener('mouseover', onOver);
    document.removeEventListener('mouseout', onOut);
    window.removeEventListener('resize', measure);
    document.documentElement.classList.remove(ROOT_CLASS);
    if (dotEl) dotEl.remove();
    if (ringEl) ringEl.remove();
  }

  function init() {
    dotEl = document.querySelector('.cursor--1');
    ringEl = document.querySelector('.cursor--2');
    if (!dotEl || !ringEl) return;

    hide();
    measure();
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
